import Experience from "../../Experience";

export default class CtaBuilder {
    static experience = null;

    constructor() {
        this.experience = new Experience();
        this.instances = document.querySelectorAll('.cta');
        this.listeners = [];
        this.build();
    }

    build() {
        this.instances.forEach((instance) => {
            if (instance._ctaListeners) {
                const { mouseOverHandler, mouseOutHandler, clickHandler } = instance._ctaListeners;
                instance.removeEventListener('mouseenter', mouseOverHandler);
                instance.removeEventListener('mouseleave', mouseOutHandler);
                instance.removeEventListener('click', clickHandler);
            }

            if (!instance.classList.contains('cta-built')) {
                const content = instance.innerHTML;
                instance.innerHTML = `
                <div class="button-textContainer">
                    <div class="main">${content}</div>
                    <div class="secondary">
                        <span><span><p>${content}</p></span></span>
                        <span><span><p>${content}</p></span></span>
                        <span><span><p>${content}</p></span></span>
                        <span><span><p>${content}</p></span></span>
                    </div>
                </div>
            `;
                instance.classList.add('cta-built');
            }

            const mouseOverHandler = (e) => this.handleMouseOver(e);
            const mouseOutHandler  = (e) => this.handleMouseOut(e);
            const clickHandler = (e) => {
                const spans = e.currentTarget.querySelectorAll('.secondary span span');
                spans.forEach(span => span.style.transform = 'translate(0, 100%)');

                const content = e.currentTarget.querySelector('.main').textContent.trim().toLowerCase();

                if (content.includes('instagram')) {
                    window.open('https://www.instagram.com/britcansat101/', '_blank');
                    return;
                } else if (content.includes('contact')) {
                    window.open('mailto:sailakedi444@gmail.com', '_blank');
                    return;
                }

                e.preventDefault();
                this.experience.router.route(e);
            };

            instance.addEventListener('mouseenter', mouseOverHandler);
            instance.addEventListener('mouseleave', mouseOutHandler);
            instance.addEventListener('click', clickHandler);

            instance._ctaListeners = { mouseOverHandler, mouseOutHandler, clickHandler };
        });
    }

    removeListeners() {
        this.listeners.forEach(({ instance, mouseOverHandler, mouseOutHandler, clickHandler }) => {
            instance.removeEventListener('mouseover', mouseOverHandler);
            instance.removeEventListener('mouseout', mouseOutHandler);
            instance.removeEventListener('click', clickHandler);
        });
        this.listeners = [];
    }

    handleMouseOver(event) {
        const spans = event.currentTarget.querySelectorAll('.secondary span span');
        spans.forEach((span, i) => {
            span.style.transform = 'translate(0, 0)';
            span.style.transitionDelay = `${i * 0.05}s`;
        });
    }

    handleMouseOut(event) {
        const spans = event.currentTarget.querySelectorAll('.secondary span span');
        const len = spans.length;
        spans.forEach((span, i) => {
            span.style.transitionDelay = `${(len - 1 - i) * 0.05}s`;
            span.style.transform = 'translate(0, -100%)';
        });
    }
}
